import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mr-4 flex items-center" }, "Showing", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "ml-4 flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("select", {
      value: _ctx.index,
      id: "select-procedure",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectProcedure && _ctx.selectProcedure(...args))),
      class: "flex-grow bg-gray-200 px-2 py-1"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.procedures, (procedure, index) => {
        return (_openBlock(), _createElementBlock("option", {
          value: index,
          key: procedure.code
        }, _toDisplayString(procedure.code), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_3),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.index + 1) + " of " + _toDisplayString(_ctx.count), 1)
  ]))
}